import { omit } from 'lodash'
import ImageMarker, { MarkerComponentProps } from 'react-image-marker'
import { PolygonMarker } from '../types'
import { Marker } from './ui/Marker'

type MarkersProps = {
  img: string
  onMarkerSelect: (marker: PolygonMarker) => void
  markers: PolygonMarker[]
}

export function PolygonMarkers({ img, onMarkerSelect, markers }: MarkersProps) {
  return (
    <ImageMarker
      src={img}
      markers={markers}
      bufferLeft={0}
      bufferTop={0}
      markerComponent={(markerProps: MarkerComponentProps) => (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() =>
            onMarkerSelect(omit(markerProps, 'itemNumber') as PolygonMarker)
          }
        >
          <Marker {...(markerProps as MarkerComponentProps & PolygonMarker)} />
        </div>
      )}
    />
  )
}
